<div class="group relative p-4 sm:p-6">
    <ng-template [ngIf]="product" [ngIfElse]="placeholder">
        <div class="relative aspect-w-1 aspect-h-1 group-hover:opacity-75">
            <kb-picture
                [src]="product.image"
                [focalPoint]='product.imageFocalPoint'
                [w]="200"
                [h]="200"
                [alt]="product.productName"
                [lazy]="lazyLoadImg"
                imgClass="aspect-square rounded border border-gray-50 shadow-sm "
            ></kb-picture>
            <div *ngIf="product.offers?.length" class="absolute flex justify-center w-full bottom-1 opacity-90">
                <div
                    class="inline-flex items-center border rounded-sm border-eastern bg-white text-xs"
                >
                    <div *ngFor="let offer of product.offers" class="px-1 py-0.5 whitespace-nowrap text-primary-800">{{ offer }}</div>
                    <div
                        class="rounded-sm rounded-l-none bg-eastern text-white px-2 py-0.5 inline-block"
                        *ngIf="product.rrpDiscount"
                    >
                        -{{ product.rrpDiscount }}%
                    </div>
                </div>
            </div>
        </div>
        <div class="pt-6 pb-4 text-center">
            <h3 class="text-sm font-medium text-gray-900">
                <a [routerLink]="['/p', product.slug]" (click)="productClick.emit()">
                    <span aria-hidden="true" class="absolute inset-0"></span>
                    <div
                        *ngIf="product.productNameHighlighted; else unHighlighted"
                        [innerHTML]="product.productNameHighlighted"
                    ></div>
                    <ng-template #unHighlighted>{{ product.productName }}</ng-template>
                </a>
            </h3>
            <kb-star-rating
                [centered]="true"
                [rating]="product.reviewRating"
                [reviewCount]="product.reviewCount"
            ></kb-star-rating>
            <div class="mt-4 text-base font-medium">
            <div *ngIf='product.rrp && product.rrp.max && product.rrp.max > product.priceWithTax.max' class="text-red-700 line-through">
                <ng-template
                    [ngIf]="product.rrp.min === product.rrp.max"
                    [ngIfElse]="rrpRange"
                >
                    {{ product.rrp.min | formatPrice }}
                </ng-template>
                <ng-template #rrpRange>
                    {{ product.rrp.min | formatPrice }} -
                    {{ product.rrp.max | formatPrice }}</ng-template
                >
            </div>
            <div *ngIf='product.priceWithTax' class="text-gray-700">
                <ng-template
                    [ngIf]="product.priceWithTax.min === product.priceWithTax.max"
                    [ngIfElse]="range"
                >
                    {{ product.priceWithTax.min | formatPrice }}
                </ng-template>
                <ng-template #range>
                    {{ product.priceWithTax.min | formatPrice }} -
                    {{ product.priceWithTax.max | formatPrice }}</ng-template
                >
            </div>
            </div>
        </div>
    </ng-template>
    <ng-template #placeholder>
        <div class="animate-pulse">
            <div class="h-32 rounded-sm bg-gray-200"></div>
            <div class="space-y-2 mt-4">
                <div class="h-2 rounded-sm bg-gray-200"></div>
                <div class="h-2 rounded-sm bg-gray-200"></div>
            </div>
        </div>
    </ng-template>
</div>
